import { Component, ElementRef, Input, OnInit, ViewContainerRef } from '@angular/core';
import { DynamicElementService } from '../../services/dynamicElement.service';
import { Issue } from '../../models/issue';
import { Sticker } from '../../models/sticker';
import { SettingsService } from '../../services/settings.service';
import { StickerService } from '../../services/sticker.service';
import { KanbanBoardViewComponent } from '../../actionviews/kanban-board-view/kanban-board-view.component';

@Component({
  selector: 'app-sticker-detail',
  templateUrl: './sticker-detail.component.html',
  styleUrls: ['./sticker-detail.component.scss']
  })
export class StickerDetailComponent implements OnInit {

  public issueContainer: Array<any>;
  private _issueIsFloating = true;
  private dynamicElementInsertionPoint: ViewContainerRef;
  public aWallViewKanban: KanbanBoardViewComponent;
  private issueHasBeenChanged = false;

  @Input() public issue: Issue;
  @Input() public sticker: Sticker;


  constructor(
    private elementRef: ElementRef,
    private dynamicElementService: DynamicElementService,
    private stickerService: StickerService,
  ) { }

  ngOnInit(): void {
    this.dynamicElementInsertionPoint = this.dynamicElementService.getInsertionPoint();
  }

  getElementRef(): ElementRef {
    return this.elementRef;
  }

  public set issueIsFloating(isFloating: boolean) {
    this._issueIsFloating = isFloating;
  }

  stickerCommentChanged(updatedComment) {
    this.sticker.comment = updatedComment;
    this.issueHasBeenChanged = true;
    // TODO: sync event
  }

  public deleteThisSticker() {
    this.stickerService.removeSticker(this.sticker).subscribe(
      (data) => {
        this.closeThisCard();
        // Remove sticker from datamodel
        const index = this.issue.stickers.indexOf(this.sticker);
        this.issue.stickers.splice(index, 1);
      });
  }

  public closeThisCard() {
    if (this.issueHasBeenChanged) {
      this.issueHasBeenChanged = false;
      this.stickerService.updateSticker(this.sticker);
    }

    if (this.aWallViewKanban) {
      this.aWallViewKanban.dynamicallyRemoveStickerCardComponent(this);
    }
  }
}
